import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ApiCommunicationService } from './api-communication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileManagementService {

  constructor(private apiCommunicationService: ApiCommunicationService) {
  }

  static serveToBrowser(blob: Blob, fileName: string): void {
    if ((navigator as any).msSaveOrOpenBlob) {
      FileManagementService.msSaveOrOpenBlob(blob, fileName);
    } else {
      FileManagementService.saveBlob(blob, fileName);
    }
  }

  static getFileNameFromHeader(response: HttpResponse<ArrayBuffer>): string {
    let fileName = '';
    if (response.headers.has('content-disposition')) {
      const disposition = response.headers.get('content-disposition');
      if (disposition.includes('attachment')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }
    }
    return fileName;
  }

  private static msSaveOrOpenBlob(blob: Blob, fileName: string): void {
    (navigator as any).msSaveOrOpenBlob(blob, fileName);
  }

  private static saveBlob(blob: Blob, fileName: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  downloadFileAndServe(k3vID: number): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.apiCommunicationService.downloadFile(k3vID).subscribe(response => {
        const blob = new Blob([response.body], { type: 'octet/stream' });
        const fileNameToCreate = FileManagementService.getFileNameFromHeader(response);
        FileManagementService.serveToBrowser(blob, fileNameToCreate);
        resolve(true);
      }, error => {
        console.error('Unable to download k3vID: ' + k3vID + ' - error: ' + error?.message?.toString());
        resolve(false);
      });
    });
  }

  uploadFile(rowKey: string, files: FormData): Observable<any> {
    return this.apiCommunicationService.uploadFile(rowKey, files);
  }
}
